import React, {useEffect, useState} from "react";
import {Skeleton, Grid, Box, Typography} from "@mui/material";
import DonutChart from "react-donut-chart";
import DateRangePickerComponent from "../../common/CustomDateRangePicker";
import moment from "moment";
import useDashboard from "../../../hooks/useDashboard";
import EmptyIcon from "../../../assets/images/empty-box.png";
import useDashboardResetFilterStore from "../../../zustand/useDashboardResetFilterStore";

const TopVerificationProductsComponent = (props) => {

  const {breakpoints} = props;

  const {isDashboardResetFilters, setDashboardResetFilters} = useDashboardResetFilterStore();
  const {topVerificationProducts, isFetchingTopVerificationProducts, getTopVerificationProducts} = useDashboard();
 
  const [startDate, setStartDate] = useState(moment().subtract(6, 'days').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const [topVerificationProductData, setTopVerificationProductData] = useState([]);

  const colors = ["#C309F1", "#F109A2", "#09D5F1", "#3939D1", "#BF40A3"];

  
  useEffect(() => {
    if (isDashboardResetFilters) {
      setStartDate(moment().subtract(6, "days").format("YYYY-MM-DD"));
      setEndDate(moment().format("YYYY-MM-DD"));
    }
  }, [isDashboardResetFilters]);

  useEffect(() => {
    if (startDate && endDate) { 
      getTopVerificationProducts(startDate, endDate);
      setDashboardResetFilters(false);
    }
  }, [startDate, endDate])

  useEffect(() => {
    if (topVerificationProducts) {
      const formattedProductsData = topVerificationProducts?.map((item, index) => ({
        label: item?.productInfo?.product_name || "N / A",
        value: item?.count,
        color: colors[index % colors.length]
      }));
  
      setTopVerificationProductData(formattedProductsData);
    }
  }, [topVerificationProducts])


  const reactDonutChartBackgroundColor = [
    "#C309F1",
    "#F109A2",
    "#09D5F1",
    "#3939D1",
    "#BF40A3",
  ]

  const reactDonutChartInnerRadius = 0.4;
  const reactDonutChartSelectedOffset = 0.04;

  const reactDonutChartHandleClick = (item, toggled) => {
    if (toggled) {
      //
    }
  }

  let reactDonutChartStrokeColor = "#FFFFFF";

  const reactDonutChartOnMouseEnter = (item) => {
    let color = topVerificationProductData?.find((q) => q.label === item.label).color;
    reactDonutChartStrokeColor = color;
  }

  const handleDateRangeChange = (startDate, endDate) => {
    setStartDate(startDate);
    setEndDate(endDate);
  }


  return (
    <Box sx={{backgroundColor: "#fff", mt: "20px", pt: "24px", borderRadius: "8px", width: "95%", ml: 3, height: "596px"}}> 
      <Grid container sx={{paddingLeft: "24px", paddingRight: "24px"}}>
        <Grid item xs={4.5} sm={4.5} md={4.5} lg={4.5} xl={4.5}>
          <Typography sx={{color: "#58565f", fontSize: 16, mb: 3, fontWeight: 600}}>
            Top Verification Products
          </Typography>
        </Grid>

        <Grid item xs={7.5} sm={7.5} md={7.5} lg={7.5} xl={7.5} sx={{textAlign: "end", justifyContent: "end", ml: "auto", display: "flex"}}>   
          <DateRangePickerComponent 
            initialStartDate={startDate}
            initialEndDate={endDate}
            ranges={{
              "Last 7 Days": [moment().subtract(6, 'days'), moment()],
              "This Month": [moment().startOf('month'), moment().endOf('month')],
              "Last Month": [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
              "Last 90 Days": [moment().subtract(89, 'days'), moment()],
            }}
            onDateRangeChange={handleDateRangeChange}
          />
        </Grid>
      </Grid>

      <Box sx={{height: "76%", display: "flex", justifyContent: "center", alignItems: "center"}}>
        {isFetchingTopVerificationProducts ?
          <Skeleton variant="rounded" width="90%" height="95%" sx={{backgroundColor: "#d8d8fdbd"}} />   
        :
          (!isFetchingTopVerificationProducts && topVerificationProductData?.length === 0) ?
            <Box sx={{textAlign: "center", p: 3}}>
              <img alt="empty-data-icon" src={EmptyIcon} width="150" />

              <Typography sx={{color: "#58565f", fontSize: 14, mt: 1}}>
                No data available for the selected date range
              </Typography>
            </Box>
        :
          <DonutChart
            onMouseEnter={(item) => reactDonutChartOnMouseEnter(item)}
            strokeColor={reactDonutChartStrokeColor}
            data={topVerificationProductData}
            colors={reactDonutChartBackgroundColor}
            innerRadius={reactDonutChartInnerRadius}
            selectedOffset={reactDonutChartSelectedOffset}
            onClick={(item, toggled) => reactDonutChartHandleClick(item, toggled)}
            className={"verificationproducts-donutchart"}
            // width={breakpoints === "xs" ? 300 : 500}
            // height={breakpoints === "xs" ? 200 : 350}
            // legend={false}
          />
        }
      </Box>
    </Box>  
  )
}

export default TopVerificationProductsComponent
